import nonVegBullet from "~/assets/images/nonVeg.svg";
import eggBullet from "~/assets/images/eggBullet.svg";
import vegBullet from "~/assets/images/veg.svg";
export const NON_VEG = {
  id: 1,
  value: "non-veg",
  label: "Non Veg",
  img: nonVegBullet,
  color: "#FF5928"
};
export const EGG = {
  id: 2,
  value: "egg",
  label: "Egg",
  img: eggBullet,
  color: "#FFC830"
};
export const VEG = {
  id: 3,
  value: "veg",
  label: "Veg",
  img: vegBullet,
  color: "#68CC72"
};
export const DISH_TYPES = [NON_VEG, EGG, VEG];
